import type {
  IntegrationRequestEmailCampaign,
  IntegrationRequestEmailDraft,
} from "@/schema/integration-request-email-campaign"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchIntegrationRequestEmailCampaigns(context: ApiContext) {
  return apiContextFetch<IntegrationRequestEmailCampaign[]>(context, "integration_request_email_campaigns")
}

export function updateIntegrationRequestEmailCampaign(
  context: ApiContext,
  campaignKey: string,
  options?: { acted?: boolean; remindLater?: boolean }
) {
  return apiContextFetch<IntegrationRequestEmailCampaign>(
    context,
    `integration_request_email_campaigns/${campaignKey}`,
    {
      method: "PATCH",
      body: options ? JSON.stringify({ acted: options.acted, remind_later: options.remindLater }) : undefined,
    }
  )
}

export function fetchIntegrationRequestEmailDraft(context: ApiContext, campaignKey: string) {
  return apiContextFetch<IntegrationRequestEmailDraft>(context, "integration_request_email_drafts", {
    method: "POST",
    body: JSON.stringify({ campaign_key: campaignKey }),
  })
}
